<template>
    <div>
        <b-row
            :class="[!item.selected ? 'font-italic' : '']"
            class="w-100 pt-3 m-0"
            align-v="start"
        >
            <div class="col-6 pl-0 pr-1 py-1">
                <b-form-checkbox
                    v-model="item.selected"
                    class="align-items-start checkbox-margin-top"
                    plain
                    @change="stateChanged"
                    >{{ item.name }}</b-form-checkbox
                >
            </div>

            <div class="col-6 p-0">
                <div class="row no-gutters">
                    <div class="col-6 pl-0">
                        <date-picker
                            v-if="item.selected"
                            class="mr-1"
                            :config="givenOptions"
                            v-model="item.givenDate"
                            @dp-show="showDatePicker"
                            name="given-date"
                            placeholder="Given (Optional)"
                        ></date-picker>
                        <date-picker
                            v-else
                            class="mr-1"
                            v-model="noData"
                            name="given-nodata"
                            placeholder="Given (Optional)"
                            :readonly="true"
                        ></date-picker>
                    </div>
                    <div class="col-6 pl-0">
                        <date-picker
                            v-if="item.selected"
                            :config="dueOptions"
                            v-model="item.dueDate"
                            @dp-show="showDatePicker"
                            name="due-date"
                            v-validate="'required'"
                            :class="{
                                'border-danger':
                                    errors.has('due-date') ||
                                    formErrors.includes('dueDate')
                            }"
                            placeholder="Due (Required)"
                        ></date-picker>
                        <date-picker
                            v-else
                            v-model="noData"
                            name="due-nodata"
                            placeholder="Due (Required)"
                            :readonly="true"
                        ></date-picker>
                    </div>
                </div>
            </div>
        </b-row>

        <hr class="mb-0" />
    </div>
</template>
<script>
import { DateTime } from "luxon";
export default {
    components: {},
    props: {
        item: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            noData: null,
            formErrors: [],
            givenOptions: {
                format: "",
                useCurrent: false
            },
            dueOptions: {}
        };
    },
    watch: {
        "item.givenDate"(value) {
            if (value && this.item.dueDuration) {
                this.item.dueDate = DateTime.fromFormat(
                    this.item.givenDate,
                    this._getLuxonFormat()
                )
                    .plus(this.item.dueDuration)
                    .toFormat(this._getLuxonFormat());
            }
            this.checkDueDate();
        },
        "item.dueDate"(value) {
            this.checkDueDate();
        }
    },
    mounted() {
        this.givenOptions.format = this.getDateFormat();
        this.dueOptions.format = this.getDateFormat();
    },
    methods: {
        showDatePicker(event) {
            // fix position of the date picker
            this._datePickerShow(event, true);
        },
        stateChanged(value) {
            if (value) {
                this.item.disabled = false;
                this.hideValue = false;
            } else {
                this.item.disabled = true;
                this.hideValue = true;
            }
            this.item.selected = value;
            this.$emit("selected-changed");
        },
        checkDueDate() {
            if (this.item.dueDate && this.item.givenDate) {
                let due = DateTime.fromFormat(
                    this.item.dueDate,
                    this._getLuxonFormat()
                );
                let given = DateTime.fromFormat(
                    this.item.givenDate,
                    this._getLuxonFormat()
                );

                if (due <= given) {
                    this.$emit("trigger-show-alert", {
                        item: this.item.id,
                        action: "add"
                    });
                    this.formErrors.push("dueDate");
                    this.formErrors.push("givenDate");
                } else {
                    this.formErrors = [];
                    this.$emit("trigger-show-alert", {
                        item: this.item.id,
                        action: "remove"
                    });
                }
            }
        }
    }
};
</script>
